import { FC } from 'react';
import { Col, Row, Switch, Typography } from 'antd';
import { TbArrowUpRight, TbCircle, TbCloudLock, TbMinusVertical } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { useEntitlements } from '@/hooks/useEntitlements';
import { PlanTag } from '@/shared';
import { useWorkspaceStore } from '@/stores';

// interface SAMLSSOProps {}

const SAMLSSO: FC = (): JSX.Element => {
    const { toggleWorkspaceSAMLSSO, selectedWorkspace } = useWorkspaceStore();

    const { token } = useAntDesignTheme();
    const { hasFeature } = useEntitlements();
    const canUseSSO = hasFeature('sso');

    const handleToggleSAMLSSOInWorkspace = (e: boolean) => {
        if (!selectedWorkspace?.id) {
            return;
        }

        void toggleWorkspaceSAMLSSO(selectedWorkspace.id, e);
    };

    return (
        <>
            <Row align={'top'} wrap={false}>
                <Col flex='auto'>
                    <Typography.Title level={4}>
                        <TbCloudLock style={{ verticalAlign: '-0.2rem', marginRight: '0.5rem' }} />
                        SAML SSO
                        <PlanTag
                            plan={'enterprise'}
                            style={{
                                verticalAlign: '0.1rem',
                                marginLeft: '0.5rem',
                            }}
                        />
                    </Typography.Title>
                    <Typography.Paragraph>
                        <span style={{ color: token.colorTextTertiary }}>Allow emails with a </span>
                        <a
                            href='https://docs.countercyclical.io/fundamentals/settings/workspace/permissions#verified-domains'
                            target='_blank'
                            rel='noreferrer'
                        >
                            verified domain
                            <TbArrowUpRight style={{ verticalAlign: '-0.15rem', marginLeft: '0.125rem' }} />
                        </a>{' '}
                        <span style={{ color: token.colorTextTertiary }}> to access this workspace.</span>
                    </Typography.Paragraph>
                </Col>
                <Col flex='none' style={{ textAlign: 'right' }}>
                    <Switch
                        disabled={!canUseSSO}
                        style={{ verticalAlign: '-1rem' }}
                        checkedChildren={<TbMinusVertical style={{ verticalAlign: '-0.125rem' }} />}
                        unCheckedChildren={<TbCircle style={{ verticalAlign: '-0.125rem' }} />}
                        checked={selectedWorkspace?.samlEnabled}
                        onChange={(e) => {
                            handleToggleSAMLSSOInWorkspace(e);
                        }}
                    />
                </Col>
            </Row>
        </>
    );
};

export default SAMLSSO;
